import { Profile } from 'apis/profile'
import { CustomLogin } from 'src/system/models'

export interface AuthStateInterface {
  accessToken: string | null
  refreshToken: string | null
  verifyToken: string | null
  profile: Profile | null
  customLogin: CustomLogin | null
}

function state(): AuthStateInterface {
  return {
    accessToken: null,
    refreshToken: null,
    verifyToken: null,
    profile: null,
    customLogin: null,
  }
}

export default state
